import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './CTA.css';

const CTA = () => {
  const { t } = useTranslation();
  
  return (
    <section className="cta-section">
      <div className="cta-background">
        <div className="glow-orb glow-orb-1"></div>
        <div className="glow-orb glow-orb-2"></div>
        <div className="glow-orb glow-orb-3"></div>
      </div>
      <div className="cta-container">
        <div className="cta-content">
          <h2>{t('cta.title')}</h2>
          <p>{t('cta.subtitle')}</p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-primary">
              {t('cta.startProject')}
            </Link>
            <Link to="/case-studies" className="btn btn-secondary">
              {t('cta.viewCaseStudies')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
